module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-11T65NMZQL","G-KY48TCW5ZB"],"pluginConfig":{"head":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"BK","short_name":"BK","start_url":"/","background_color":"#F5F5F5","theme_color":"#C5944B","display":"minimal-ui","icon":"src/images/logo.png","cache_busting_mode":"none"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
